import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles';
import colors from 'vuetify/lib/util/colors'
import {createVuetify} from 'vuetify';
import {aliases, mdi} from 'vuetify/iconsets/mdi';
import {md3} from 'vuetify/blueprints';
import * as components from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'

const ballad = {
  dark: false,
  colors: {
    background: colors.grey.lighten5,
    surface: colors.grey.lighten4,
    primary: colors.indigo.darken4,
    secondary: '#03DAC6',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: colors.amber.base,
  },
};

const lightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#6200EE',
    'primary-darken-1': '#3700B3',
    secondary: '#03DAC6',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  theme: {
    defaultTheme: 'ballad',
    themes: {
      ballad,
      lightTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    }
  },
  // blueprint: md3,
});
